import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'astral-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  template: `
    <form
      class="astral-form"
      [formGroup]="form"
      [attr.autocomplete]="autocomplete"
      [attr.novalidate]="novalidate ? '' : null"
      [style.--astral-form-grid-template-columns]="resolvedGridTemplateColumns"
      [style.--astral-form-tablet-grid-template-columns]="resolvedTabletGridTemplateColumns"
      [style.--astral-form-mobile-grid-template-columns]="resolvedMobileGridTemplateColumns"
      [style.column-gap]="columnGap"
      [style.row-gap]="rowGap || null"
      (ngSubmit)="onSubmit()"
    >
      <ng-content></ng-content>
    </form>
  `,
  styleUrls: ['./astral-form.component.scss'],
})
export class AstralFormComponent {
  @Input() autocomplete = 'off';
  @Input() columns = 3;
  @Input() tabletColumns: number;
  @Input() mobileColumns: number;

  @Input() form: FormGroup;
  @Input() minColumnWidth = '220px';
  @Input() novalidate = true;

  // Leave the default rhythm to CSS so direct surface sections can use their own gap.
  @Input() rowGap: string | null = null;
  @Input() columnGap = 'var(--astral-form-column-gap, var(--spacing-xl, 24px))';

  @Output() formSubmit = new EventEmitter<void>();

  get resolvedGridTemplateColumns(): string {
    if (!this.columns || this.columns < 1) {
      return `repeat(auto-fit, minmax(${this.minColumnWidth}, 1fr))`;
    }

    return `repeat(${this.columns}, minmax(0, 1fr))`;
  }

  get resolvedTabletGridTemplateColumns(): string | null {
    if (this.tabletColumns && this.tabletColumns > 0) {
      return `repeat(${this.tabletColumns}, minmax(0, 1fr))`;
    }

    if (!this.columns || this.columns < 1) {
      return null;
    }

    return `repeat(${Math.min(this.columns, 2)}, minmax(0, 1fr))`;
  }

  get resolvedMobileGridTemplateColumns(): string | null {
    if (this.mobileColumns && this.mobileColumns > 0) {
      return `repeat(${this.mobileColumns}, minmax(0, 1fr))`;
    }

    if (!this.columns || this.columns < 1) {
      return null;
    }

    return `repeat(${Math.min(this.columns, 1)}, minmax(0, 1fr))`;
  }

  onSubmit(): void {
    this.form?.markAllAsTouched();
    this.formSubmit.emit();
  }

  resetForm(): void {
    this.form?.reset();
  }
}
